import { RedocStandalone } from "redoc";
import React from "react";
import { useParams } from 'react-router-dom';


export const Services = ()=>  {

  const { service } = useParams();

  return <>
    <div className={"redoc-wp"}>
      <RedocStandalone
        definitionUrl={`/spec/${service}.yaml`}
        router="history"
        options={{
          routingBasePath: `/services/${service}`,
          scrollYOffset: 65,
        }}
      />
    </div>
  </>
}